import type { DataOperationDefinition, YearlyRecordSplitArgs } from "../../types";
import { isValidMonthDay } from "../../primitives/monthDay";
import { applyYearlyRecordSplit } from "./apply";
import ArgsForm from "./ArgsForm";

const yearlyRecordSplit: DataOperationDefinition<YearlyRecordSplitArgs> = {
  id: "yearlyRecordSplit",
  displayName: "Yearly Record Split",
  description:
    "Splits continuous time-series data into one series per calendar year, normalized onto the same x-axis for visual comparison. " +
    "Use Start/End (month + day, no year) to scope each year to a specific season — e.g. Oct 1 → May 31 for snowpack. " +
    "When the range wraps the year boundary, series are labeled as seasons (e.g. \"2024-2025\").",
  defaultArgs: { startMonthDay: null, endMonthDay: null },
  validateArgs: (args) => {
    if (args.startMonthDay && !isValidMonthDay(args.startMonthDay)) return "Invalid Start Date";
    if (args.endMonthDay && !isValidMonthDay(args.endMonthDay)) return "Invalid End Date";
    return null;
  },
  apply: applyYearlyRecordSplit,
  ArgsForm,
};

export default yearlyRecordSplit;
